import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { useCorporateFieldsContext } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/hooks/useCorporateFieldsContext';

export interface TermSelectProps {
  name: string;
  id: string;
}

export function TermSelect({ name, id }: TermSelectProps): JSX.Element {
  const { control, errors } = useFormContext();
  const { corpFieldsData } = useCorporateFieldsContext();
  const termOptions = corpFieldsData?.terms || [];

  return (
    termOptions && (
      <CookbookSelectWrapper
        label="Term *"
        name={name}
        id={id}
        options={termOptions}
        error={errors[name]}
        control={control}
        blockWidth
        rules={{
          required: 'Term option is required',
        }}
      />
    )
  );
}
